export const API_BASE = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8000');

// Token muddati tugaganda avtomatik refresh qilish
async function refreshAccessToken() {
  const refreshToken = localStorage.getItem('refresh_token');
  if (!refreshToken) return null;

  try {
    const res = await fetch(API_BASE + '/api/refresh', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ refresh_token: refreshToken }),
    });
    if (res.ok) {
      const data = await res.json();
      localStorage.setItem('access_token', data.access_token);
      return data.access_token;
    } else {
      // Refresh token ham eskirgan — logout
      logout();
      return null;
    }
  } catch (err) {
    return null;
  }
}

export const apiFetch = async (url, options = {}) => {
  const token = localStorage.getItem('access_token');
  const headers = new Headers(options.headers || {});

  if (token) {
    headers.set('Authorization', 'Bearer ' + token);
  }

  let response = await fetch(url, { ...options, headers });

  // Agar 401 bo'lsa — refresh token bilan qayta urinish
  if (response.status === 401) {
    const newToken = await refreshAccessToken();
    if (newToken) {
      headers.set('Authorization', 'Bearer ' + newToken);
      response = await fetch(url, { ...options, headers });
    }
  }

  return response;
};

export const logout = () => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('token_type');
  localStorage.removeItem('web_password');
  window.location.reload();
};
